import { Component, Input, Optional, SkipSelf } from '@angular/core';
import {
  AbstractControl,
  FormGroupDirective,
  ValidationErrors,
} from '@angular/forms';
import { KeyValuePipe, NgForOf, NgIf } from '@angular/common';

@Component({
  selector: 'app-field-error',
  templateUrl: './field-error.component.html',
  standalone: true,
  imports: [NgIf, NgForOf, KeyValuePipe],
})
export class FieldErrorComponent {
  @Input() public controlName!: string;
  @Input() public control!: AbstractControl;

  private get formControl(): AbstractControl {
    return this.control || this.parentControl?.control?.get(this.controlName);
  }

  public get showMessage(): boolean {
    return this.formControl?.invalid && this.formControl?.touched;
  }

  public get errorMessage(): ValidationErrors {
    return this.formControl.errors!['error'];
  }

  constructor(
    @Optional()
    @SkipSelf()
    private parentControl: FormGroupDirective
  ) {}
}
